"use strict";

exports.default = exports.Intersect = void 0;
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj &&
        typeof Symbol === "function" &&
        obj.constructor === Symbol &&
        obj !== Symbol.prototype
        ? "symbol"
        : typeof obj;
    };
  }
  return _typeof(obj);
}
function inserted(el, binding) {
  var modifiers = binding.modifiers || {};
  var value = binding.value;
  var { handler, options } =
    _typeof(value) === "object"
      ? value
      : {
          handler: value,
          options: {},
        };
  var observer = new IntersectionObserver(function() {
    let argLen = arguments.length;
    var entries = argLen > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var observer = argLen ? arguments[1] : undefined;
    if (!el._observe) return; 
    if (handler && (!modifiers.quiet || el._observe.init)) {
      var isIntersecting = Boolean(
        entries.find(function(entry) {
          return entry.isIntersecting;
        })
      );
      var ratio = entries[0].intersectionRatio;
      handler(entries, observer, isIntersecting, ratio);
    } 
    if (el._observe.init && modifiers.once) unbind(el);
    // Otherwise, mark the observer as initted
    else el._observe.init = true;
  }, options);
  el._observe = {
    init: false,
    observer: observer,
  };
  observer.observe(el);
}
function unbind(el) {
  if (!el._observe) return;
  el._observe.observer.unobserve(el);
  delete el._observe;
}
var Intersect = {
  inserted: inserted,
  unbind: unbind,
};
exports.Intersect = Intersect;
var _default = Intersect;
exports.default = _default;

// 